import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettingsService } from '../app/appSettings.service';

@Injectable()
export class AuthenticationService {

  private url_root: string;
  private headersConfig: HttpHeaders;

  constructor(private http: HttpClient, private SettingsService: AppSettingsService) {

    this.url_root = `${SettingsService.getApiAddress()}/`;
    this.headersConfig = SettingsService.getHeadersConfig();
  }

  getWorkflowLogin(login: string, password: string) {

    const data = JSON.stringify({ login: login, password: password, systemKey: 'Workflow' });

    return this.http.post(`${this.url_root}Authentication/Authenticate`, data, { headers: this.headersConfig });

  }
}
